export default __webpack_public_path__ + "static/media/104.464297c8.jpeg";